export const errorDate = "Please specify the expiration date";

export const routersDoctor = {
  table: "/table",
  schedule: "/schedule",
  personal_info: "/personal-info",
  dashboard: "/dashboard",
  emr: "/emr",
  request: "/request",
  info_request: "/info-request",
  template: "/template",
};

export const filtersCalendar = ["My visits", "All Visits"];

export const notificationsText = {
  completedRegistration:
    "Please complete the registration process within 10 days",
  appointment:
    "Your Employment Application is Complete. You will be notified when the Administrator reviews your Application. Thank you!",
  updateFiles: "Please Update Files That Were Flagged",
  waitingReview:
    "New patient appointment NOW. Please accept the assignment Now.",
};

export const STATUSES_EVENTS = {
  accepted: "accepted",
  assigned: "assigned",
  rejected: "rejected",
};

export const placeholdersPMH = {
  pmh: "Past Medical History",
  familySocial: "Family / Social History",
  medications: "Medications",
  allergies: "Allergies to medications",
};

export const pastTestResultsText = {
  title: "Past Test Results",
  recent: "Recent",
  viewAllDocuments: "view all documents",
  allTestResults: "All test results",
  emptyValue: "—",
  columns: {
    name: "Name",
    visitDate: "Visit date",
    visitType: "Visit type",
    physician: "Physician",
    specialty: "Specialty",
  },
  filters: {
    visitType: "Visit Type",
    visitDate: "Visit Date",
    physician: "Physician",
    specialty: "Specialty",
    clearAll: "Clear All",
    filter: "Filter",
    filters: "Filters",
  },
};

export const modesTemplate = {
  render: "render",
  preview: "preview",
  check: "check",
};

export const sidebarButtonsText = [
  "Confirm",
  "Confirm",
  "5 Mins left",
  "I'm Here",
  "Visit Complete",
  "",
  "Add Service",
  "",
  "Visit Complete",
  "Submit Patient",
];
